(function () {
  var OPEN_HOUR  = 12;
  var CLOSE_HOUR = 18;

  function initClock() {
    var el = document.getElementById('nav-clock');
    if (!el) return;

    var dateFmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Taipei',
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });
    var timeFmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Taipei',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    var hourFmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Taipei',
      hour: 'numeric',
      hour12: false,
    });

    function checkOpen() {
      return parseInt(hourFmt.format(new Date()), 10) >= OPEN_HOUR &&
             parseInt(hourFmt.format(new Date()), 10) < CLOSE_HOUR;
    }

    // Build DOM structure once
    el.innerHTML =
      '<span class="nav-dot"></span>' +
      '<span class="nav-clock__time">' +
        '<span class="nav-clock__date"></span>' +
        ' <span class="nav-clock__h"></span>' +
        '<span class="nav-clock__colon">:</span>' +
        '<span class="nav-clock__m"></span>' +
        ' (TAIPEI)' +
      '</span>' +
      '<span class="nav-clock__status"></span>';

    var dotEl    = el.querySelector('.nav-dot');
    var dateEl   = el.querySelector('.nav-clock__date');
    var hEl      = el.querySelector('.nav-clock__h');
    var colonEl  = el.querySelector('.nav-clock__colon');
    var mEl      = el.querySelector('.nav-clock__m');
    var statusEl = el.querySelector('.nav-clock__status');

    var colonVisible = true;

    function tick() {
      var now    = new Date();
      var open   = checkOpen();
      var parts  = timeFmt.format(now).split(':');

      dotEl.className    = 'nav-dot nav-dot--' + (open ? 'open' : 'closed');
      dateEl.textContent = dateFmt.format(now);
      hEl.textContent    = parts[0];
      mEl.textContent    = parts[1];
      statusEl.textContent = open ? 'SHOP OPEN' : 'SHOP CLOSED';

      colonVisible = !colonVisible;
      colonEl.style.opacity = colonVisible ? '1' : '0';
    }

    el.addEventListener('click', function (e) {
      e.preventDefault();
      el.classList.toggle('is-status');
    });

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClock);
  } else {
    initClock();
  }
})();
